<div class="bg_calculator">
  <app-headercontent></app-headercontent>
  <div class="container" *ngIf="model == null">
    <div class="identity">
      Recuperando presupuesto...
    </div>
  </div>
  <div class="container mb-3" *ngIf="model != null">
    <a class="back__link" [routerLink]="['/specifications/'+model.IdBudget]">Cambiar información</a>
  </div>
  <div class="bg_selected_car pt-3 pb-7">
    <div class="container">
      <div class="row" *ngIf="model != null">
        <div class="col-md-8 service__options">
          <div class="cont__advice">
            <div class="icon">
              <img src="../../../../assets/images/icons/advice-icon.svg" alt="Aviso importante">
            </div>
            <div class="advice">Aquí tienes las operaciones recomendadas según la edad y el kilometraje de tu CUPRA. Si quieres, puedes añadir otras operaciones al presupuesto. Tu Especialista CUPRA te comunicará qué operaciones son finalmente necesarias.</div>
          </div>
          <h4>Operaciones de mantenimiento programadas</h4>
          <div class="operation__date">Operaciones recomendadas para un vehículo con {{model.PitstopKm | number}} km o {{model.PitstopMonths}} meses ({{model.PitstopMonths | monthsToYear}})</div>
          <div *ngIf="model != null && model.HasMaintenance" class="cont__advice strong-advice">
            <div class="icon">
              <img src="../../../../assets/images/icons/advice-icon.svg" alt="Aviso importante">
            </div>
            <div class="advice">Recuerda que tienes contratado el plan de mantenimiento, por lo que las operaciones que ves aquí no tienen ningún coste para ti, exceptuando las de desgaste.</div>
          </div>
          <div class="row">
            <div [ngClass]="{'col-xl-6 col-lg-12': showCupraCare, 'col-md-12': !showCupraCare}">
              <ng-container *ngFor="let op of operationsModel; let i = index">
                <div class="card" (click)="SelectMantenimiento(op)" id="op{{i}}">
                  <div class="card-body">
                    <div class="title__select cursor__pointer">
                      <div class="op_{{op.OperationCode}}"></div>
                      <div class="title__operation cursor__pointer">
                        {{op.Operation}}
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="cost__operation cursor__pointer">{{op.FinalPrice | currency: 'EUR'}}</div>
                    <div class="actions">
                      <button *ngIf="op.HasHtml" type="button" class="btn btn-info" (click)="openOperationModal(op)">+ Info</button>
                      <button *ngIf="!op.Included" type="button" class="btn btn-add" (click)="SelectMantenimiento(op)">
                        <img src="../../../../assets/images/icons/add-icon.svg" alt="Añadir servicio">
                      </button>
                      <button *ngIf="op.Included" type="button" class="btn btn-add" (click)="SelectMantenimiento(op)">
                        <img src="../../../../assets/images/icons/quit-icon.svg" alt="Eliminar servicio">
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="col-xl-6 col-lg-12" *ngIf="showCupraCare">
              <cupra-care [IdBudget]="model.IdBudget"></cupra-care>
            </div>
          </div>

          <div class="row" *ngIf="piezasModel.length > 0">
            <div class="col-md-12">
              <h4>Piezas de desgaste habituales</h4>

              <ng-container *ngFor="let pieza of piezasModel; let i = index">
                <div id="pieza{{i}}" class="card" (click)="SelectPieza(pieza)">
                  <div class="card-body">
                    <div class="title__select cursor__pointer" (click)="SelectPieza(pieza)">
                      <!--<div class="{{pieza.Class}}"></div>-->
                      <div class="title__operation cursor__pointer">
                        {{pieza.Description}}
                      </div>
                    </div>
                  </div>
                  <!--Footer cuando solo hay una opción-->
                  <div class="card-footer" *ngIf="pieza.CupraPiezaDesgasteOptions.length == 1">
                    <div class="cost__operation">{{pieza.SelectedOptionPrice | currency: 'EUR'}}</div>
                    <div class="actions">
                      <button *ngIf="pieza.HasHtml" type="button" class="btn btn-info" (click)="openPiezaModal(pieza)">+ Info</button>
                      <button *ngIf="!pieza.Included" type="button" class="btn btn-add" (click)="SelectPieza(pieza)">
                        <img src="../../../../assets/images/icons/add-icon.svg" alt="Añadir servicio">
                      </button>
                      <button *ngIf="pieza.Included" type="button" class="btn btn-add" (click)="SelectPieza(pieza)">
                        <img src="../../../../assets/images/icons/quit-icon.svg" alt="Eliminar servicio">
                      </button>
                    </div>
                  </div>

                  <!--Footer cuando hay varias opciones-->
                  <div class="card-footer" *ngIf="pieza.CupraPiezaDesgasteOptions.length > 1">
                    <div class="cost__operation">{{pieza.SelectedOptionDesc}} {{pieza.SelectedOptionPrice | currency: 'EUR'}}</div>
                    <div class="actions">
                      <button type="button" class="btn btn-info" (click)="openPiezaModal(pieza)">+ Opciones</button>
                      <button *ngIf="!pieza.Included" type="button" class="btn btn-add" (click)="SelectPieza(pieza)">
                        <img src="../../../../assets/images/icons/add-icon.svg" alt="Añadir servicio">
                      </button>
                      <button *ngIf="pieza.Included" type="button" class="btn btn-add" (click)="SelectPieza(pieza)">
                        <img src="../../../../assets/images/icons/quit-icon.svg" alt="Eliminar servicio">
                      </button>
                    </div>
                  </div>

                </div>
              </ng-container>

            </div>
          </div>


        </div>

        <div class="col-md-4">
          <div class="bg-white">

            <budget-summary [model]="model"></budget-summary>
            <div class="cont__actions_budget-summary">
              <div class="cont__download">
                <a (click)="sendBudget(true)" class="link__download">Descargar presupuesto</a>
              </div>
              <div class="w-100">
                <ng-container *ngIf="sendingEmailBudget">
                  <div class="alert alert-secondary" role="alert">
                    Si desea enviar el presupuesto a otra dirección de email debe esperar 60 segungos.
                  </div>
                </ng-container>
                <ng-container *ngIf="!sendingEmailBudget">
                  <div class="form-floating mb-3">
                    <input [(ngModel)]="email" type="text" class="form-control" id="email" placeholder="Introduce aquí tu email">
                    <label for="email">Introduce aquí tu email</label>
                    <div *ngIf="showValidationEmailError == true" class="invalid-feedback d-block">Debes introducir una dirección de email válida</div>
                    <div *ngIf="showValidationOperationError == true" class="invalid-feedback d-block">Debes seleccionar alguna operación</div>
                  </div>
                  <div class="mb-3">
                    <div class="legal-button-box mb-3">
                      <p>Te informamos que SEAT, S.A. es el responsable del tratamiento de tus datos, y que tratará la información de tu dirección de correo electrónico con la finalidad de enviarte un presupuesto orientativo del mantenimiento del vehículo para las operaciones recomendadas según la edad y kilometraje que ha seleccionado. Puedes consultar la forma de ejercer tus derechos de protección de datos, así como obtener información completa en nuestra <a href="https://www.cupraofficial.es/politica-privacidad.html" target="_blank">Política de Privacidad</a>. Más información: <a href="mailto:privacy@cupraofficial.es">privacy@cupraofficial.es</a></p>
                    </div>
                    <button type="button" (click)="sendBudget()" class="btn btn-primary w-100" [disabled]="sendingEmailBudget">
                      Enviar presupuesto por email
                    </button>
                  </div>
                </ng-container>
                <div>
                  <button *ngIf="model.CcDate" class="btn btn-primary w-100" disabled>Ya has pedido cita</button>
                  <button *ngIf="!model.CcDate" (click)="sendBudget(false,true)" type="button" class="btn btn-primary w-100"> Pedir cita</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>